import conferenceConfig from './conference'
import registration from './registration'
// NOTE: in order to not have a circular dependency, none of the other phases can import this file. It can only import from the other phases.
const afterConferenceConfig = {
  starts: conferenceConfig.ends,
  ends: registration.starts,
}

export default afterConferenceConfig
